module.exports = __webpack_public_path__ + "static/assets/f7bed206888170bb7e11cafcd2e2c230.svg";